AFRAME.registerComponent('camera-rig-handler-v4', {
    schema: {
        speed: { type: 'number', default: 0.1 },
        desktopFov: { type: 'number', default: 60 },
        vrFov: { type: 'number', default: 90 },
        pseudoVrFov: { type: 'number', default: 60 },
        minFov: { type: 'number', default: 10 },
        maxFov: { type: 'number', default: 120 },
        desktopZoomNear: { type: 'number', default: 1 },
        desktopZoomFar: { type: 'number', default: -2.0 },
        pseudoVrZoomNear: { type: 'number', default: -0.3 },
        pseudoVrZoomFar: { type: 'number', default: 0.85 },
        vrZoomNear: { type: 'number', default: 0.8 },
        vrZoomFar: { type: 'number', default: 1.15 },
        pseudoVrHeight: { type: 'number', default: 0.9 },
        desktopHeight: { type: 'number', default: 0.20 },
        currentScroll: { type: 'number', default: 0 },
    },

    init: function () {
        this.isMouseDown = false;
        this.isPinching = false;
        this.previousPinchDistance = 0;
        this.previousMouse = { x: 0, y: 0 };
        this.leftStickLastData = { x: 0, y: 0 };
        this.rightStickLastData = { x: 0, y: 0 };
        this.cameraRig = this.el;
        this.camera = document.getElementById('camera');
        if (!this.camera) {
            console.error('Camera not found!');
            return;
        }

        // this.lockHeights = [0.5, 0.7, 0.9, 1.1, 1.3]; // Only for true VR
        this.lockHeights = [0.3, 0.6, 0.9, 1.2, 1.4]; // Only for true VR
        // this.lockHeights = [0, 0.2, 0.4, 0.6, 0.8]; // Only for true VR
        // this.lockHeights = [0.8, 1.0, 1.2, 1.4, 1.6]; // Only for true VR

        this.fullBillboards = new Set();
        this.xBillboards = new Set();
        this.yBillboards = new Set();
        this.lastCameraPosition = new AFRAME.THREE.Vector3();
        this.camera.object3D.getWorldPosition(this.lastCameraPosition);

        this.togglePopupControllerDebounceTimeout = null;
        this.togglePopupControllerLastCall = 0;

        this.setupCameraRig();
        this.setupResetView();
        this.setupEventListeners();
        this.setupBillboardObserver();
        this.setupPopupListener();
        this.setupGlobalFunctions();

        this.handleResetCamera = this.resetCamera.bind(this);
        this.handleUpdateBillboards = this.updateBillboards.bind(this);
        this.handleRefreshBillboards = this.refreshBillboards.bind(this);

        this.el.addEventListener('reset-camera', (event) => { this.handleResetCamera(event.detail.message); });
        this.el.addEventListener('update-billboards', this.handleUpdateBillboards);
        this.el.addEventListener('update-billboards-list', this.updateBillboardsList.bind(this));
        this.el.addEventListener('refresh-billboards', this.handleRefreshBillboards);

        this.isDraggingUI = false;
        this.el.sceneEl.addEventListener('drag-move-start', () => { this.isDraggingUI = true; });
        this.el.sceneEl.addEventListener('drag-move-end', () => { this.isDraggingUI = false; });
        this.el.sceneEl.addEventListener('app-state-changed', this.handleAppStateChange.bind(this));

        this.updateControls();

        this.currentLockIndex = 1;
        this.currentVerticalLockIndex = 1;
        this.wasNeutral = true;
        this.wasVerticalNeutral = true;

        this.setInitialFov();
        this.updateFov();

        this.tick = this.tick.bind(this);

        this.el.sceneEl.addEventListener('loaded', () => {
            this.bindEvents();
            if (window.AppState.isTrueVRMode) {
                console.log('Scene loaded in true VR, setting up controllers');
                this.setupControllers();
            }
            this.updateBillboards();
        });

        this.handleEnterVRBound = this.handleEnterVR.bind(this);
        this.handleExitVRBound = this.handleExitVR.bind(this);
        this.el.sceneEl.addEventListener('enter-vr', this.handleEnterVRBound);
        this.el.sceneEl.addEventListener('exit-vr', this.handleExitVRBound);

        document.addEventListener('click', this.focusCanvas = () => this.el.sceneEl.canvas.focus());
    },

    handleAppStateChange: function (event) {
        const state = event.detail.state;
        console.log('App state changed:', state);

        if (state.isPseudoVRMode) {
            console.log('Switching to pseudoVR mode');
            this.setupCameraRigVR();
            this.resetCameraVR('near');
        } else if (state.isTrueVRMode) {
            console.log('Switching to true VR mode');
            this.setupCameraRigVR();
            this.setupControllers();
        } else if (state.isDesktopMode) {
            console.log('Switching to desktop mode');
            this.setupCameraRigDesktop();
            this.resetCameraDesktop('near');
            const canvas = this.el.sceneEl.canvas;
            if (canvas) {
                canvas.focus();
                console.log('Canvas refocused for mouse input');
            }
        }

        this.updateControls();
        this.el.emit('refresh-billboards');
    },

    isVRMode: function () {
        return window.AppState.isTrueVRMode || window.AppState.isPseudoVRMode;
    },

    setInitialFov: function () {
        // if (window.AppState.isTrueVRMode) {
        //     this.currentFov = this.data.vrFov;
        // } else if (window.AppState.isPseudoVRMode) {
        //     this.currentFov = this.data.pseudoVrFov;
        // } else {
        //     this.currentFov = this.data.desktopFov;
        // }
        // this.currentFov = Math.max(this.data.minFov, Math.min(this.data.maxFov, this.currentFov));
        this.currentFov = 45
    },

    setupCameraRig: function () {
        if (window.AppState.isPseudoVRMode || window.AppState.isTrueVRMode) {
            this.setupCameraRigVR();
        } else {
            this.setupCameraRigDesktop();
        }
    },

    setupCameraRigDesktop: function () {
        // this.cameraRig.setAttribute('position', `0 ${this.data.desktopHeight} ${this.data.desktopZoomNear}`);
        const zoomNear = this.data.vrZoomNear;
        this.cameraRig.setAttribute('position', `0 ${this.lockHeights[1]} ${zoomNear}`);
        this.cameraRig.setAttribute('rotation', '0 0 0');
        this.camera.removeAttribute('look-controls');
        this.camera.setAttribute('look-controls-enabled', 'false');
        this.camera.removeAttribute('wasd-controls');
        this.camera.setAttribute('look-controls', 'enabled: false');
        this.camera.setAttribute('wasd-controls', 'enabled: false');
        this.currentFov = Math.max(this.data.minFov, Math.min(this.data.maxFov, this.data.desktopFov));
        this.updateFov();
        this.bindEvents();
    },

    setupCameraRigVR: function () {
        // if (window.AppState.isPseudoVRMode) {
        if (window.AppState.isPseudoVRMode) {
            // this.cameraRig.setAttribute('position', `0 ${this.data.pseudoVrHeight} ${this.data.pseudoVrZoomNear}`);
            this.cameraRig.setAttribute('rotation', '0 0 0');
            this.camera.removeAttribute('look-controls');
            this.camera.removeAttribute('wasd-controls');
            this.camera.setAttribute('look-controls', 'enabled: false');
            this.camera.setAttribute('look-controls-enabled', 'false');
            this.camera.setAttribute('wasd-controls', 'enabled: false');
            this.currentFov = this.data.pseudoVrFov;
            this.removeEvents(); // Explicitly remove mouse events
        } else if (window.AppState.isTrueVRMode) {
            // const zoomNear = this.data.vrZoomNear;
            // this.cameraRig.setAttribute('position', `0 ${this.lockHeights[1]} ${zoomNear}`);
            this.cameraRig.setAttribute('rotation', '0 0 0');
            this.camera.setAttribute('look-controls', 'enabled: false');
            this.camera.setAttribute('look-controls-enabled', 'false');
            this.camera.setAttribute('wasd-controls', 'enabled: false');
            this.currentFov = this.data.vrFov;
            this.removeEvents();
        }
        const zoomNear = this.data.vrZoomNear;
        this.cameraRig.setAttribute('position', `0 ${this.lockHeights[1]} ${zoomNear}`);
        this.updateFov();
    },

    setupControllers: function () {
        if (!window.AppState.isTrueVRMode) {
            console.log('Not in true VR mode, skipping controller setup');
            return;
        }

        console.log('Setting up controllers for true VR');
        this.leftHand = document.getElementById('leftHand');
        this.rightHand = document.getElementById('rightHand');

        if (!this.leftHand || !this.rightHand) {
            console.warn('Controllers not found:', { left: this.leftHand, right: this.rightHand });
            return;
        }

        this.leftHand.setAttribute('oculus-touch-controls', 'hand: left');
        this.rightHand.setAttribute('oculus-touch-controls', 'hand: right');
        this.leftHand.setAttribute('visible', 'true');
        this.rightHand.setAttribute('visible', 'true');
        const leftLabel = document.createElement('a-text');
        leftLabel.setAttribute('value', 'Strafe/Elevate (Stick)\nHeights (Y/X)');
        leftLabel.setAttribute('position', '0.02 -0.01 -0.055');
        leftLabel.setAttribute('rotation', '-90 -9 -1');
        leftLabel.setAttribute('scale', '0.04 0.04 0.04');
        leftLabel.setAttribute('align', 'center');
        leftLabel.setAttribute('color', 'white');
        this.leftHand.appendChild(leftLabel);

        const rightLabel = document.createElement('a-text');
        rightLabel.setAttribute('value', 'Pan/Zoom (Stick)\n(A) Reset View Far / (B) Reset View Near');
        rightLabel.setAttribute('position', '-0.02 -0.01 -0.055');
        rightLabel.setAttribute('rotation', '-90 9 -1');
        rightLabel.setAttribute('scale', '0.04 0.04 0.04');
        rightLabel.setAttribute('align', 'center');
        rightLabel.setAttribute('color', 'white');
        this.rightHand.appendChild(rightLabel);

        console.log('Controllers initialized:', { left: this.leftHand, right: this.rightHand });
        this.bindControllerEvents(this.leftHand, this.rightHand);
    },

    setupResetView: function () {
        this.handleKeydownBound = this.handleKeydown.bind(this);
        window.addEventListener('keydown', this.handleKeydownBound);
    },

    handleKeydown: function (event) {
        if (event.key === 'R' || event.key === 'r') {
            if (!this.isVRMode()) {
                console.log('R key pressed, resetting camera in desktop mode');
                this.resetCamera('near');
            }
        }
    },

    bindEvents: function () {
        const canvas = this.el.sceneEl.canvas;
        if (!canvas) {
            console.error('Canvas not found!');
            return;
        }
        canvas.focus();
        canvas.addEventListener('wheel', this.handleMouseWheelBound);
        document.addEventListener('mousedown', this.handleMouseDownBound);
        document.addEventListener('mouseup', this.handleMouseUpBound);
        document.addEventListener('mousemove', this.handleMouseMoveBound);

        document.addEventListener('touchstart', this.handleMouseDownBound, { passive: false });
        document.addEventListener('touchend', this.handleMouseUpBound);
        document.addEventListener('touchcancel', this.handleMouseUpBound);
        document.addEventListener('touchmove', this.handleMouseMoveBound, { passive: false });
        console.log('Custom mouse events bound for desktop mode');
    },

    removeEvents: function () {
        const canvas = this.el.sceneEl.canvas;
        if (canvas) {
            canvas.removeEventListener('wheel', this.handleMouseWheelBound);
        }
        document.removeEventListener('mousedown', this.handleMouseDownBound);
        document.removeEventListener('mouseup', this.handleMouseUpBound);
        document.removeEventListener('mousemove', this.handleMouseMoveBound);

        document.removeEventListener('touchstart', this.handleMouseDownBound);
        document.removeEventListener('touchend', this.handleMouseUpBound);
        document.removeEventListener('touchcancel', this.handleMouseUpBound);
        document.removeEventListener('touchmove', this.handleMouseMoveBound);
        console.log('Mouse events removed');
    },

    setupEventListeners: function () {
        this.handleMouseWheelBound = (event) => {
            if (this.isVRMode()) return;
            this.handleMouseWheel(event);
        };

        this.handleMouseDownBound = (event) => {
            const isTouch = event.type && event.type.startsWith('touch');

            if (isTouch && event.touches && event.touches.length >= 2) {
                this.isPinching = true;
                const dx = event.touches[0].clientX - event.touches[1].clientX;
                const dy = event.touches[0].clientY - event.touches[1].clientY;
                this.previousPinchDistance = Math.sqrt(dx * dx + dy * dy);
                this.isMouseDown = false;
                return;
            }

            this.isPinching = false;
            this.isMouseDown = true;
            this.previousMouse.x = isTouch && event.touches ? event.touches[0].clientX : event.clientX;
            this.previousMouse.y = isTouch && event.touches ? event.touches[0].clientY : event.clientY;
        };

        this.handleMouseUpBound = (event) => {
            const isTouch = event.type && event.type.startsWith('touch');

            if (isTouch) {
                if (event.touches.length === 0) {
                    this.isMouseDown = false;
                    this.isPinching = false;
                } else if (event.touches.length === 1) {
                    if (this.isPinching) {
                        this.isMouseDown = false;
                        this.isPinching = false;
                    } else {
                        this.previousMouse.x = event.touches[0].clientX;
                        this.previousMouse.y = event.touches[0].clientY;
                    }
                }
            } else {
                this.isMouseDown = false;
                this.isPinching = false;
            }
        };

        this.handleMouseMoveBound = (event) => {
            const isTouch = event.type && event.type.startsWith('touch');

            if (this.isPinching && isTouch && event.touches && event.touches.length >= 2) {
                if (event.cancelable) event.preventDefault();

                const dx = event.touches[0].clientX - event.touches[1].clientX;
                const dy = event.touches[0].clientY - event.touches[1].clientY;
                const distance = Math.sqrt(dx * dx + dy * dy);
                const distanceDiff = this.previousPinchDistance - distance;

                // Emulate mouse wheel event
                const syntheticEvent = {
                    deltaY: distanceDiff * 3
                };

                this.handleMouseWheel(syntheticEvent);
                this.previousPinchDistance = distance;
                return;
            }

            if (!this.isMouseDown) return;
            this.handleMouseMove(event);
        };
    },

    setupBillboardObserver: function () {
        const scene = this.el.sceneEl;

        const applyOrientation = (mutations) => {
            let billboardAdded = false;
            mutations.forEach(mutation => {
                if (mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            if (node.classList?.contains('billboard')) {
                                this.fullBillboards.add(node);
                                billboardAdded = true;
                            }
                            if (node.classList?.contains('billboard-x')) {
                                this.xBillboards.add(node);
                                billboardAdded = true;
                            }
                            if (node.classList?.contains('billboard-y')) {
                                this.yBillboards.add(node);
                                billboardAdded = true;
                            }
                        }
                    });
                }

                if (mutation.removedNodes.length > 0) {
                    mutation.removedNodes.forEach(node => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            this.fullBillboards.delete(node);
                            this.xBillboards.delete(node);
                            this.yBillboards.delete(node);
                        }
                    });
                }

                if (mutation.type === 'attributes' && mutation.target.nodeType === Node.ELEMENT_NODE) {
                    const node = mutation.target;
                    const hasBillboard = node.classList.contains('billboard');
                    const hasBillboardX = node.classList.contains('billboard-x');

                    if (hasBillboard && !this.fullBillboards.has(node)) {
                        this.fullBillboards.add(node);
                        billboardAdded = true;
                    } else if (!hasBillboard && this.fullBillboards.has(node)) {
                        this.fullBillboards.delete(node);
                    }

                    if (hasBillboardX && !this.xBillboards.has(node)) {
                        this.xBillboards.add(node);
                        billboardAdded = true;
                    } else if (!hasBillboardX && this.xBillboards.has(node)) {
                        this.xBillboards.delete(node);
                    }
                }
            });
            if (billboardAdded) this.updateBillboards();
        };

        const observer = new MutationObserver(applyOrientation);
        observer.observe(scene, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
        document.querySelectorAll('.billboard').forEach(el => this.fullBillboards.add(el));
        document.querySelectorAll('.billboard-x').forEach(el => this.xBillboards.add(el));
        document.querySelectorAll('.billboard-y').forEach(el => this.yBillboards.add(el));
        console.log('Billboard observer set up', document.querySelectorAll('.billboard-x'), this.xBillboards)

        this.observer = observer;

        setTimeout(() => this.updateBillboards(), 0);
    },

    updateBillboardsList: function () {
        this.fullBillboards = new Set();
        this.xBillboards = new Set();
        this.yBillboards = new Set();

        document.querySelectorAll('.billboard').forEach(el => this.fullBillboards.add(el));
        document.querySelectorAll('.billboard-x').forEach(el => this.xBillboards.add(el));
        document.querySelectorAll('.billboard-y').forEach(el => this.yBillboards.add(el));
    },

    handleMouseMove: function (event) {
        if (!this.isMouseDown || this.isDraggingUI) return;

        const isTouch = event.type && event.type.startsWith('touch');
        if (isTouch && event.cancelable) event.preventDefault();

        let clientX = isTouch ? event.touches[0].clientX : event.clientX;
        let clientY = isTouch ? event.touches[0].clientY : event.clientY;

        let deltaX = clientX - this.previousMouse.x;
        let deltaY = clientY - this.previousMouse.y;
        this.previousMouse.x = clientX;
        this.previousMouse.y = clientY;

        let rotation = this.cameraRig.object3D.rotation;
        rotation.y -= deltaX * 0.005;
        rotation.x -= deltaY * 0.005;
        rotation.x = Math.max(-Math.PI / 2, Math.min(Math.PI / 2, rotation.x));
        this.cameraRig.object3D.rotation.set(rotation.x, rotation.y, 0);
        this.el.emit('refresh-billboards');
    },

    handleMouseWheel: function (event) {
        let direction = new THREE.Vector3();
        this.camera.object3D.getWorldDirection(direction);
        let zoomFactor = event.deltaY * 0.005;
        let newPosition = this.cameraRig.object3D.position.clone().add(direction.multiplyScalar(zoomFactor));

        let minZoom = -10;
        let maxZoom = 15;
        if (newPosition.z > minZoom && newPosition.z < maxZoom) {
            this.cameraRig.object3D.position.copy(newPosition);
        }
        this.el.emit('refresh-billboards');
    },

    updateFov: function () {
        this.camera.setAttribute('camera', 'fov', this.currentFov);

        const sceneWrapper = document.querySelector('#scene-wrapper')
        if (sceneWrapper && this.isVRMode()) {
            sceneWrapper.setAttribute('position', '0 0 0')
        }
    },

    bindControllerEvents: function (leftHand, rightHand) {
        if (!leftHand || !rightHand) {
            console.warn('One or both VR controllers not found, skipping event binding');
            return;
        }

        console.log('Binding controller events for true VR');

        const events = [
            'thumbstickmoved', 'thumbstickdown', 'thumbstickup',
            'abuttondown', 'bbuttondown', 'xbuttondown', 'ybuttondown',
            'triggerdown', 'gripdown', 'selectstart', 'squeezestart'
        ];

        events.forEach(event => {
            leftHand.addEventListener(event, (e) => {
                console.log(`Left ${event}:`, e.detail || 'No detail');
                this.handleControllerEvent('left', event, e.detail);
            });
            rightHand.addEventListener(event, (e) => {
                console.log(`Right ${event}:`, e.detail || 'No detail');
                this.handleControllerEvent('right', event, e.detail);
            });
        });
    },

    handleControllerEvent: function (hand, event, detail) {
        if (!window.AppState.isTrueVRMode) return;

        if (hand === 'left') {
            if (event === 'thumbstickmoved') {

                this.leftStickLastData = detail || { x: 0, y: 0 }

            } else if (event === 'ybuttondown') {

                if (this.currentVerticalLockIndex < this.lockHeights.length - 1) {
                    this.currentVerticalLockIndex++;
                    this.cameraRig.object3D.position.y = this.lockHeights[this.currentVerticalLockIndex];
                    this.updateBillboards();
                }
            } else if (event === 'xbuttondown') {
                if (this.currentVerticalLockIndex > 0) {
                    this.currentVerticalLockIndex--;
                    this.cameraRig.object3D.position.y = this.lockHeights[this.currentVerticalLockIndex];
                    this.updateBillboards();
                }
            }
        } else if (hand === 'right') {
            if (event === 'thumbstickmoved') {
                this.rightStickLastData = detail || { x: 0, y: 0 };
            } else if (event === 'abuttondown') {
                this.resetCamera('far');
                this.updateBillboards();
            } else if (event === 'bbuttondown') {
                this.resetCamera('near');
                this.updateBillboards();
            } else if (event === 'squeezestart' || event === 'gripdown') {
                const now = Date.now();
                const timeSinceLastCall = now - this.togglePopupControllerLastCall;

                if (timeSinceLastCall < 300) {
                    return;
                }

                if (this.togglePopupControllerDebounceTimeout) {
                    clearTimeout(this.togglePopupControllerDebounceTimeout);
                    this.togglePopupControllerDebounceTimeout = null;
                }
                this.togglePopupControllerDebounceTimeout = setTimeout(() => {
                    this.togglePopupControllerLastCall = Date.now();
                    this.togglePopupControllerDebounceTimeout = null;

                    try {
                        if (typeof this.togglePopupController === 'function') {
                            this.togglePopupController();
                        } else if (window.togglePopupController && typeof window.togglePopupController === 'function') {
                            window.togglePopupController();
                        } else {
                            console.error(`[camera-rig-handler-v4] togglePopupController not found!`);
                        }
                    } catch (error) {
                        console.error(`[camera-rig-handler-v4] Error calling togglePopupController:`, error);
                    }
                }, 50);
            }
        }
    },

    resetCamera: function (zoom = 'far') {
        if (this.isVRMode()) {
            this.resetCameraVR(zoom);
        } else {
            this.resetCameraDesktop(zoom);
        }
    },

    resetCameraDesktop: function (zoom = 'far') {
        const zPos = zoom === 'far' ? this.data.desktopZoomFar : this.data.desktopZoomNear;
        this.cameraRig.object3D.position.set(0, this.data.desktopHeight, zPos);
        this.cameraRig.object3D.rotation.set(0, 0, 0);
        this.camera.object3D.rotation.set(0, 0, 0);
        this.camera.removeAttribute('look-controls');
        this.camera.removeAttribute('wasd-controls');
        this.camera.setAttribute('look-controls', 'enabled: false');
        this.camera.setAttribute('look-controls-enabled', 'false');
        this.camera.setAttribute('wasd-controls', 'enabled: false');
        this.currentFov = Math.max(this.data.minFov, Math.min(this.data.maxFov, this.data.desktopFov));
        this.updateFov();
        this.el.emit('refresh-billboards');
        this.bindEvents();
    },

    resetCameraVR: function (zoom = 'far') {
        if (window.AppState.isPseudoVRMode) {
            const zPos = zoom === 'far' ? this.data.pseudoVrZoomFar : this.data.pseudoVrZoomNear;
            this.cameraRig.object3D.position.set(0, this.data.pseudoVrHeight, zPos);
            this.cameraRig.object3D.rotation.set(0, 0, 0);
            this.currentFov = this.data.pseudoVrFov;
            this.el.emit('refresh-billboards');
        } else if (window.AppState.isTrueVRMode) {
            const zoomFar = this.data.vrZoomFar;
            const zoomNear = this.data.vrZoomNear;
            const zPos = zoom === 'far' ? zoomFar : zoomNear;
            this.cameraRig.object3D.position.set(0, this.lockHeights[1], zPos);
            this.cameraRig.object3D.rotation.set(0, 0, 0);
            this.currentLockIndex = 1;
            this.currentVerticalLockIndex = 1;
            this.wasNeutral = true;
            this.wasVerticalNeutral = true;
            this.currentFov = this.data.vrFov;
            this.updateBillboards();
        }
        this.updateFov();
    },

    updateBillboards: function () {
        const currentCameraPosition = new AFRAME.THREE.Vector3();
        this.camera.object3D.getWorldPosition(currentCameraPosition);

        this.fullBillboards.forEach(el => {
            if (el.object3D) {
                const adjustedPosition = currentCameraPosition.clone();
                adjustedPosition.y -= 0.3;
                el.object3D.lookAt(adjustedPosition);
            }
        });

        this.xBillboards.forEach(el => {
            if (el.object3D) {
                const objectWorldPos = new AFRAME.THREE.Vector3();
                el.object3D.getWorldPosition(objectWorldPos);

                const direction = currentCameraPosition.clone().sub(objectWorldPos);
                const currentRotation = el.object3D.rotation;
                const targetX = Math.atan2(direction.z, direction.y) - Math.PI / 2;
                el.object3D.rotation.set(targetX, currentRotation.y, currentRotation.z);
            }
        });

        this.yBillboards.forEach(el => {
            if (el.object3D) {
                const objectWorldPos = new AFRAME.THREE.Vector3();
                el.object3D.getWorldPosition(objectWorldPos);

                const direction = currentCameraPosition.clone().sub(objectWorldPos);
                const targetWorldY = Math.atan2(direction.x, direction.z);

                let parentWorldY = 0;
                if (el.object3D.parent) {
                    const parentWorldQuat = new AFRAME.THREE.Quaternion();
                    el.object3D.parent.getWorldQuaternion(parentWorldQuat);
                    parentWorldY = new AFRAME.THREE.Euler().setFromQuaternion(parentWorldQuat, 'YXZ').y;
                }

                const currentRotation = el.object3D.rotation;
                el.object3D.rotation.set(currentRotation.x, targetWorldY - parentWorldY, currentRotation.z);
            }
        });

        this.lastCameraPosition.copy(currentCameraPosition);
    },

    refreshBillboards: function () {
        if (!window.AppState.isTrueVRMode) {
            this.updateBillboards();
        }
    },

    updateControls: function () {
        if (this.isVRMode()) {
            this.camera.removeAttribute('wasd-controls');
            this.camera.removeAttribute('look-controls');
            this.camera.setAttribute('wasd-controls', 'enabled: false');
            this.camera.setAttribute('look-controls-enabled', 'false');
            this.camera.setAttribute('look-controls', 'enabled: false');
            this.bindEvents();
            if (window.AppState.isTrueVRMode) {
                this.camera.setAttribute('wasd-controls', 'enabled: false');
                this.camera.setAttribute('look-controls-enabled', 'false');
                this.camera.setAttribute('look-controls', 'enabled: false');
                this.camera.setAttribute('look-down-check', '');
                if (this.leftHand) this.leftHand.setAttribute('visible', 'true');
                if (this.rightHand) this.rightHand.setAttribute('visible', 'true');
            }
        } else {
            this.camera.removeAttribute('wasd-controls');
            this.camera.removeAttribute('look-controls');
            this.camera.setAttribute('wasd-controls', 'enabled: false');
            this.camera.setAttribute('look-controls-enabled', 'false');
            this.camera.setAttribute('look-controls', 'enabled: false');
            this.bindEvents();
            if (this.leftHand) this.leftHand.setAttribute('visible', 'false');
            if (this.rightHand) this.rightHand.setAttribute('visible', 'false');
        }
    },

    handleEnterVR: function () {
        console.log('Entering VR mode');
        this.setupCameraRigVR();
        if (window.AppState.isTrueVRMode) {
            this.setupControllers();
        }
        this.updateControls();
        this.el.emit('refresh-billboards');
    },

    handleExitVR: function () {
        console.log('Exiting VR mode');
        this.setupCameraRigDesktop();
        this.updateControls();
        this.el.emit('refresh-billboards');
    },

    tick: function () {
        let billboardsNeedUpdate = false;

        if (this.leftStickLastData) {
            const { x, y } = this.leftStickLastData;

            if (x > 0.2 || x < -0.2) {
                const rightVec = new THREE.Vector3(1, 0, 0);
                rightVec.applyQuaternion(this.camera.object3D.getWorldQuaternion(new THREE.Quaternion()));
                this.cameraRig.object3D.position.add(rightVec.multiplyScalar(this.data.speed * x));
                billboardsNeedUpdate = true;
            }

            if (y < -0.2 || y > 0.2) {
                this.cameraRig.object3D.position.y += this.data.speed * -y;
                billboardsNeedUpdate = true;
            }
        }

        if (this.rightStickLastData) {
            const { x, y } = this.rightStickLastData;

            if (x > 0.2 || x < -0.2) {
                const rotation = this.cameraRig.object3D.rotation;
                rotation.y -= x * 0.02;
                this.cameraRig.object3D.rotation.set(0, rotation.y, 0);
                billboardsNeedUpdate = true;
            }

            if (y < -0.2 || y > 0.2) {
                const direction = new THREE.Vector3();
                this.camera.object3D.getWorldDirection(direction);
                const position = this.cameraRig.object3D.position.clone();
                position.add(direction.multiplyScalar(this.data.speed * y));
                if (position.length() < 25 || position.length() > -3) {
                    this.cameraRig.object3D.position.copy(position);
                    billboardsNeedUpdate = true;
                }
            }
        }

        if (billboardsNeedUpdate) {
            this.updateBillboards();
        }
    },

    setupGlobalFunctions: function () {
        const handler = this;

        window.attachPopupToController = function (controller) {
            console.log(`[window.attachPopupToController] Called with: ${controller}`);
            return handler.attachPopupToController(controller);
        };

        window.togglePopupController = function () {
            console.log(`[window.togglePopupController] Called from global function`);
            return handler.togglePopupController();
        };

        window.getPopupController = function () {
            if (window.StockPopupController) {
                return window.StockPopupController.currentController;
            }
            return 'right';
        };

        console.log('[camera-rig-handler-v4] Global functions available:');
        console.log('  - window.attachPopupToController("left" | "right")');
        console.log('  - window.togglePopupController()');
        console.log('  - window.getPopupController()');
    },

    setupPopupListener: function () {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1 && node.hasAttribute && node.hasAttribute('popup-look-at-camera-3d')) {
                        setTimeout(() => {
                            if (window.StockPopupController && node.components && node.components['popup-look-at-camera-3d']) {
                                const component = node.components['popup-look-at-camera-3d'];
                                if (component.data.attachToController && component.data.attachToController !== '') {
                                    const currentController = window.StockPopupController.currentController;
                                    if (currentController && component.data.attachToController !== currentController) {
                                        node.setAttribute('popup-look-at-camera-3d', 'attachToController', currentController);
                                        console.log(`[camera-rig-handler-v4] Updated newly created popup to controller: ${currentController}`);
                                    }
                                }
                            }
                        }, 100);
                    }
                });
            });
        });

        const centerPanelContent = document.getElementById('large-center-panel-content');
        if (centerPanelContent) {
            observer.observe(centerPanelContent, { childList: true, subtree: true });
        }

        observer.observe(this.el.sceneEl, { childList: true, subtree: true });

        this.popupObserver = observer;
    },

    attachPopupToController: function (controller) {
        console.log(`[camera-rig-handler-v4] attachPopupToController called with: ${controller}`);

        if (controller !== 'left' && controller !== 'right') {
            console.error(`[camera-rig-handler-v4] Invalid controller: ${controller}. Must be 'left' or 'right'`);
            return;
        }

        if (!window.StockPopupController) {
            window.StockPopupController = {
                currentController: 'right'
            };
        }

        const oldController = window.StockPopupController.currentController;
        window.StockPopupController.currentController = controller;

        const controllerId = controller === 'left' ? 'leftHand' : 'rightHand';
        const targetController = document.getElementById(controllerId);
        if (targetController) {
            if (!targetController.hasAttribute('oculus-touch-controls')) {
                targetController.setAttribute('oculus-touch-controls', `hand: ${controller}`);
            }
            if (targetController.object3D) {
                targetController.object3D.updateMatrixWorld(true);
            }
        }

        const updatePopup = (popup, index) => {
            if (popup.components && popup.components['popup-look-at-camera-3d']) {
                const component = popup.components['popup-look-at-camera-3d'];

                const shouldHaveController = window.StockPopupController && window.StockPopupController.currentController;

                if (shouldHaveController) {
                    component.data.attachToController = controller;
                    popup.setAttribute('popup-look-at-camera-3d', 'attachToController', controller);
                    component.updateController();
                    const controllerId = controller === 'left' ? 'leftHand' : 'rightHand';
                    const targetController = document.getElementById(controllerId);
                    if (targetController && targetController.object3D) {
                        targetController.object3D.updateMatrixWorld(true);

                        const timeoutId = setTimeout(() => {
                            const currentGlobalController = window.StockPopupController && window.StockPopupController.currentController;
                            if (currentGlobalController && currentGlobalController !== controller) {
                                return;
                            }

                            component.updateController();
                            if (component.controller && component.controller.object3D) {
                                const expectedControllerId = controller === 'left' ? 'leftHand' : 'rightHand';
                                if (component.controller.id === expectedControllerId) {
                                    const targetPos = component.getControllerPosition();
                                    if (targetPos) {
                                        const localPos = component.worldToLocalPosition(targetPos);
                                        popup.setAttribute('position', localPos);
                                    }
                                }
                            }
                        }, 50);

                        if (!popup._popupUpdateTimeout) {
                            popup._popupUpdateTimeout = timeoutId;
                        } else {
                            clearTimeout(popup._popupUpdateTimeout);
                            popup._popupUpdateTimeout = timeoutId;
                        }
                    } else {
                        console.warn(`[camera-rig-handler-v4] Controller ${controllerId} not found or has no object3D`);
                    }
                }
            }
        };

        const popups = new Set();

        const popupsBySelector = document.querySelectorAll('[popup-look-at-camera-3d]');
        popupsBySelector.forEach(p => {
            popups.add(p);
        });

        const popupById = document.getElementById('stock-popup');
        if (popupById) {
            popups.add(popupById);
        }

        const popupFullById = document.getElementById('stock-popup-full');
        if (popupFullById) {
            popups.add(popupFullById);
        }

        const popupsByClass = document.querySelectorAll('.stock-popup, .stock-popup-full');
        popupsByClass.forEach(p => {
            if (p.hasAttribute('popup-look-at-camera-3d')) {
                popups.add(p);
            }
        });

        const centerPanelContent = document.getElementById('large-center-panel-content');
        if (centerPanelContent) {
            const popupInPanel = centerPanelContent.querySelector('#stock-popup');
            if (popupInPanel) {
                popups.add(popupInPanel);
            }
            const popupFullInPanel = centerPanelContent.querySelector('#stock-popup-full');
            if (popupFullInPanel) {
                popups.add(popupFullInPanel);
            }
            const popupsInPanel = centerPanelContent.querySelectorAll('[popup-look-at-camera-3d]');
            popupsInPanel.forEach(p => {
                popups.add(p);
            });
        }

        const sceneEl = this.el.sceneEl;
        if (sceneEl) {
            const popupsInScene = sceneEl.querySelectorAll('[popup-look-at-camera-3d]');
            popupsInScene.forEach(p => {
                popups.add(p);
            });
        }

        if (popups.size === 0) {
            console.log(`[camera-rig-handler-v4] No popups found to update`);
            return;
        }

        console.log(`[camera-rig-handler-v4] Found ${popups.size} popups to update from ${oldController} to ${controller}`);

        Array.from(popups).forEach((popup, index) => {
            updatePopup(popup, index);
        });
        setTimeout(() => {
            Array.from(popups).forEach((popup) => {
                if (popup.components && popup.components['popup-look-at-camera-3d']) {
                    const component = popup.components['popup-look-at-camera-3d'];
                    const currentGlobalController = window.StockPopupController && window.StockPopupController.currentController;

                    if (currentGlobalController && currentGlobalController === controller) {
                        component.updateController();
                        const expectedControllerId = controller === 'left' ? 'leftHand' : 'rightHand';
                        if (component.controller && component.controller.id === expectedControllerId) {
                            const targetPos = component.getControllerPosition();
                            if (targetPos) {
                                const localPos = component.worldToLocalPosition(targetPos);
                                popup.setAttribute('position', localPos);
                            }
                        }
                    }
                }
            });
        }, 100);
    },

    togglePopupController: function () {
        if (!window.StockPopupController) {
            window.StockPopupController = {
                currentController: 'right'
            };
        }

        const current = window.StockPopupController.currentController;
        const newController = current === 'left' ? 'right' : 'left';

        this.attachPopupToController(newController);
    },

    remove: function () {
        this.el.removeEventListener('reset-camera', this.handleResetCamera);
        this.el.removeEventListener('update-billboards', this.handleUpdateBillboards);
        this.el.removeEventListener('refresh-billboards', this.handleRefreshBillboards);
        this.el.sceneEl.removeEventListener('app-state-changed', this.handleAppStateChange);
        this.removeEvents();
        document.removeEventListener('click', this.focusCanvas);
        window.removeEventListener('keydown', this.handleKeydownBound);
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.popupObserver) {
            this.popupObserver.disconnect();
        }
    }
});
